import {atom} from 'recoil';
export const themeState = atom({
  key: "themeState",
  default: {
    primaryColor: '#556cd6',
    secondaryColor: '#19857b',
    mode: window ? window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light' : 'dark',
  },
})
